<!-- Header -->
@if (mode === WidgetMode.Edit) {
  <div class="row">
    <div class="col-12 dashboard-panel-header-flex-container">
      <span class="h3"> <!--No title--></span>
      <div>
        <button class="btn btn-light dashboard-panel-button" (click)="onDelete()">
          <span class="icon-trash-can" style="color:red"></span>
        </button>
      </div>
    </div>
  </div>
}
<!-- Content -->
<div class="row" style="height:100%">
  <div class="col-12">
    <div class="logo-container">
      <img class="app-logo" (click)="onClickPicture($event)" [src]="imagePath">
    </div>
  </div>
</div>

